import Router from '../routing/router';
import AppStorage from '../storage/app-storage';
import popupHandler from '../popups/handler';
import onPopupOpen from '../events/popup-open';
import onNewContentLoaded from '../events/new-content-loaded';
import onPageShow from '../events/pageshow';
import initAdManager from '../adverts';
import { updateAlertsStatus } from '../user/alerts';
import accountControls from '../user/account-widgets';
import initSuggestLanguagePopup from '../suggestlanguage';
import saveFromElement from '../user/save-from-element';
import exitIntent from '../user/exit-intent';
import requestIdleCallback from '../shims/requestIdleCallback';
import initMainNavigation from '../navigation';
import initSelectElements from '../selects/global';
import initAlertPopups from '../alert-popups';
import initSentry from '../logging/sentry';
import { getFetchAPI } from '../http';
import { initGlobalErrorLogger } from '../logging/errors';
import { initVhUnit } from './vh';
import { initGoogleAnalyticHandlers } from '../analytics/ga';
import initCopyToClipboardButtons from '../clipboard/buttons';
import initPopupOpener from '../popups/opener';
import { initCollapsingElements } from '../collapse';
import { initDropdowns } from '../dropdown';
import { storeSessionStartTime } from '../session/time';
import { onUpdateSavedStatus, updateSavedCounter } from '../user/saved';
import { initPopupAltCloseMethods } from '../popups/close-handler';
import { onPopupClose, onPopupCloseAfter } from '../events/popup-close';
import { setLastSearchResultPageCookie } from '../cookies';
import { initGenericForms } from '../simpleform';
import { initFlashMsg } from '../flash';
import { initGradientLoader } from '../loadingindicator/gradient';
import { initTWCGlobalClickEvents } from '../analytics/twc/clicks-events';
import { initOnChangeSubmitForms } from '../forms/onchange-submit';
import { initContactButtons } from '../navigation/contact-btns';
import initCharacterLimit from '../characterlimit';
import Discardable from '../property/discard';
import Logger from '../logging/logger';
import { initClickToRevealTelephoneNumbers } from '../user/telephone';

class GlobalContext {
    constructor() {
        initSentry();

        initGlobalErrorLogger();

        Logger.info( 'setting up global context' );

        window.http = getFetchAPI();

        window.router = new Router();

        window.appStorage = new AppStorage();

        storeSessionStartTime();

        initVhUnit();

        this._registerGlobalEvents();

        this._initialiseGlobalComponents();
    }

    _registerGlobalEvents(): void {
        window.addEventListener( 'pageshow', onPageShow );

        window.addEventListener( 'twc:newcontentloaded', onNewContentLoaded );

        window.addEventListener( 'twc:popup:open', onPopupOpen );

        window.addEventListener( 'twc:popup:close', onPopupClose );

        window.addEventListener( 'twc:popup:close:after', onPopupCloseAfter );

        window.addEventListener( 'twc:navigation', popupHandler );

        window.addEventListener( 'twc:update-saved-status', onUpdateSavedStatus );

        window.addEventListener( 'twc:update-saved-counter', updateSavedCounter );
    }

    _initialiseGlobalComponents(): void {
        initMainNavigation();

        initOnChangeSubmitForms();

        initAdManager();

        accountControls();

        initSuggestLanguagePopup();

        saveFromElement();

        initPopupAltCloseMethods();

        exitIntent();

        initAlertPopups();

        initGoogleAnalyticHandlers();

        initTWCGlobalClickEvents();

        initCopyToClipboardButtons();

        initPopupOpener();

        initGenericForms( document, true );

        initFlashMsg();

        initSelectElements();

        initCollapsingElements();

        initDropdowns();

        initGradientLoader();

        initContactButtons();

        initClickToRevealTelephoneNumbers();

        initCharacterLimit();

        requestIdleCallback( updateAlertsStatus );

        new Discardable();

        document.dispatchEvent( new CustomEvent( 'twc:update-saved-status', {
            bubbles: true,
        } ) );

        if ( window.setSearchResultPageCookie && window.setSearchResultPageCookie === true ) {
            setLastSearchResultPageCookie();
        }
    }
}

export default GlobalContext;
